// tslint:disable: max-file-line-count
import React from 'react';
import { Card, Container, Grid } from '@material-ui/core';
import { t } from '../../i18n';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';
import { ReactComponent as CompletedIcon } from '../../assets/icons/completed.svg';
import Routes from '../../modules/Navigator/Navigator.route';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import EmailPopup from './components/EmailPopup';
import ConfirmationDialog from '../../components/ConfirmationDialog/ConfirmationDialog';
import { getCookie, parseJSON } from 'src/utils/common.util';
import { useCookies } from 'react-cookie';
import {
  AccordionDetailsWrapper,
  AccordionWrapper,
  ButtonGroupWrapper,
  ButtonText,
  CardContentWrapper,
  CenteredButtonWrapper,
  FormItem,
  PhoneLink,
  Title,
  TypographyWrapper,
  useStyles
} from './components/PatientDocument.style';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton.component';
import API from 'src/api/api';
import { APP_CONSTANT } from 'src/constants';
import LoadingContainer from 'src/components/LoadingContainer/LoadingContainer';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { pathOr } from 'ramda';
import ErrorImg from 'src/assets/icons/error.png';
interface IProps {
  cookies: {
    userInfo: {
      name: { nameFirst: string; nameLast: string };
      id: string;
    };
  };
}

const PatientDocument: React.FC<IProps> = ({ cookies }) => {
  const history = useHistory();
  const [showPopup, setShowPopup] = React.useState<boolean>(false);
  const [showConfirmPopup, setConfirmShowPopup] = React.useState<boolean>(
    false
  );
  const [rawDocuments, setRawDocuments] = React.useState<any>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isLoadingEmail, setIsLoadingEmail] = React.useState<boolean>(false);
  const [listDocument, setListDocument] = React.useState<any>([]);
  const [numberDocument, setNumberDocument] = React.useState<number>(0);
  const [expanded, setExpanded] = React.useState<string | false>('panel0');
  const [errorResponse, setErrorResponse] = React.useState<boolean>(false);
  const [isErrorWhenSendEmail, setIsErrorWhenSendEmail] = React.useState<
    boolean
  >(false);

  const role = getCookie('role');
  const [cookie] = useCookies([]);
  const userInfo = cookie.userInfo;
  const contactId = pathOr('', ['id'])(userInfo);
  const classes = useStyles();
  const token = getCookie('token');
  const tenantInfo = parseJSON('tenantInfo');
  const guestSubmission = sessionStorage.getItem('guestSubmission');

  const {
    values,
    touched,
    errors,
    dirty,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    resetForm,
    setErrors
  } = useFormik({
    initialValues: {
      subject: '',
      content: ''
    },
    validationSchema: Yup.object().shape({
      subject: Yup.string().trim().required('Required'),
      content: Yup.string().trim().required('Required')
    }),
    onSubmit: async (submittingValues) => {
      setIsLoadingEmail(true);

      const payload = {
        body: submittingValues.content,
        subject: submittingValues.subject,
        recipientEmail: getTenantInfoByKey('emailAddress')
      };
      try {
        await API().post(`/user/v1/messages/emails`, {
          ...payload
        });
        resetForm({});
        setShowPopup(false);
        setIsErrorWhenSendEmail(false);
      } catch (err) {
        setIsErrorWhenSendEmail(true);
      } finally {
        setIsLoadingEmail(false);
      }
    }
  });

  const formatPhoneNumber = (str) => {
    const cleaned = str.toString().replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return null;
  };

  const handleRenderAction = (item: {
    id: string;
    name?: string;
    status: string;
    secureId: string;
    secureSubmissionId?: string;
    submissionId?: number;
    ownerId?: string;
  }) => {
    const goToIndividualForm = () => {
      if (item.secureId && item.secureSubmissionId) {
        history.push(
          `${Routes.FormSubmission}/${item.id}/${item.secureId}/${
            item.submissionId
          }/${item.secureSubmissionId}${
            item.ownerId !== null ? `?ownerId=${item.ownerId}` : ''
          }`
        );

        return;
      }
      history.push(
        `${Routes.FormSubmission}/${item.id}/${item.secureId}${
          item.ownerId !== null ? `?ownerId=${item.ownerId}` : ''
        }`
      );
    };

    switch (item.status) {
      case 'pending':
        return (
          <div className={classes.buttonWrapper}>
            <PrimaryButton
              title={t('general.start')}
              variant="contained"
              titleClassName="patient-document"
              isShowIcon={true}
              onClick={goToIndividualForm}
            />
          </div>
        );
      case 'completed':
        return (
          <ButtonGroupWrapper>
            <CenteredButtonWrapper>
              <EditIcon />
              <ButtonText
                className={classes.textLink}
                onClick={goToIndividualForm}
              >
                {t('patientDocument.editSubmission')}
              </ButtonText>
            </CenteredButtonWrapper>
            <CenteredButtonWrapper className={classes.ml30}>
              <CompletedIcon className={classes.completedIcon} />
              <ButtonText className={classes.textDescription}>
                {t('patientDocument.complete')}
              </ButtonText>
            </CenteredButtonWrapper>
          </ButtonGroupWrapper>
        );
      default:
        return <div>draft</div>;
    }
  };

  const showDialog = () => {
    setShowPopup(true);
  };

  const hideDialog = () => {
    if (dirty) {
      setConfirmShowPopup(true);
    } else {
      setShowPopup(false);
      setErrors({});
    }
  };

  const handleConfirmClosingEmail = () => {
    resetForm({});
    setErrors({});
    setConfirmShowPopup(false);
    setShowPopup(false);
  };

  const handleDenyClosingEmail = () => {
    setConfirmShowPopup(false);
  };

  const getTitleName = (titleForLegal: string) => {
    if (!role) {
      return t('patientDocument.guestForm');
    }
    if (role === APP_CONSTANT.ROLE_SINGLE_USER) {
      return `${cookies.userInfo.name.nameFirst} ${cookies.userInfo.name.nameLast}'s Forms`;
    }

    return `${titleForLegal}'s Forms`;
  };

  const handleChangeAccordion = (panel: string) => (
    event: React.ChangeEvent<{}>,
    newExpanded: boolean
  ) => {
    setExpanded(newExpanded ? panel : false);
  };

  const urlQuery = () => {
    if (!token) {
      return `/user/v1/public/guest/documents/?accountId=${getTenantInfoByKey(
        'accountId'
      )}`;
    }

    return 'user/v1/documents';
  };

  const getTenantInfoByKey = (key) => {
    if (Array.isArray(key)) {
      return pathOr('', [...key])(tenantInfo);
    }

    return pathOr('', [key])(tenantInfo);
  };

  React.useEffect(() => {
    setIsLoading(true);

    const requests = [API().get(urlQuery())];

    if (role === APP_CONSTANT.ROLE_LEGAL_GUARDIAN) {
      requests.push(API().get('user/v1/family/documents'));
    }

    Promise.all(requests)
      .then((data) => {
        setErrorResponse(false);
        const [currentDocuments, familiyDocuments] = data;

        let allRawDocuments: any[] = [];

        if (currentDocuments && currentDocuments.data) {
          currentDocuments.data.nameFirst = pathOr('', ['name', 'nameFirst'])(
            userInfo
          );
          currentDocuments.data.nameLast = pathOr('', ['name', 'nameLast'])(
            userInfo
          );

          currentDocuments.data.contactId = pathOr('', ['id'])(userInfo);

          allRawDocuments = [(currentDocuments as any).data];
        }

        if (familiyDocuments && familiyDocuments.data) {
          allRawDocuments = [...allRawDocuments, ...familiyDocuments.data];
        }

        setRawDocuments(allRawDocuments);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorResponse(true);
      });
  }, []);

  React.useEffect(() => {
    if (rawDocuments.length) {
      let num = 0;
      if (role === APP_CONSTANT.ROLE_LEGAL_GUARDIAN) {
        rawDocuments.forEach((item) => {
          num += item.totalResults;
        });
      }
      if (!token || role === APP_CONSTANT.ROLE_SINGLE_USER) {
        num = pathOr(0, ['0', 'totalResults'])(rawDocuments);
      }

      setNumberDocument(num);
    }

    return;
  }, [rawDocuments]);

  React.useEffect(() => {
    const newList = rawDocuments.map((documentSection) => {
      const mappedItemArray = documentSection.documents.map((formItem) => {
        if (!token && guestSubmission) {
          let clonedFormItem = { ...formItem };

          try {
            setErrorResponse(false);
            JSON.parse(guestSubmission || '[]').map((guestSubmissionItem) => {
              if (Number(formItem.id) !== Number(guestSubmissionItem.id)) {
                return;
              }
              clonedFormItem = {
                ...formItem,
                ...guestSubmissionItem,
                status: 'completed'
              };
            });
          } catch (error) {
            setErrorResponse(true);
          }

          return clonedFormItem;
        }

        return formItem;
      });

      return {
        ...documentSection,
        documents: mappedItemArray
      };
    });
    setListDocument(newList);
  }, [guestSubmission, token, rawDocuments]);

  React.useEffect(() => {
    setListDocument((prev) =>
      prev.map((item) => {
        if (item.contactId === pathOr(undefined, ['userInfo', 'id'])(cookies)) {
          return {
            ...item,
            nameFirst: cookies.userInfo.name.nameFirst,
            nameLast: cookies.userInfo.name.nameLast
          };
        }

        return item;
      })
    );
  }, [cookies]);

  return (
    <LoadingContainer isLoading={isLoading}>
      <Container className={classes.pt50}>
        {errorResponse ? (
          <img src={ErrorImg} alt="Logo" className="img-error" />
        ) : (
          <>
            <Title className={classes.mb15}>{t('patientDocument.title')}</Title>

            <p className={`${classes.textDescription} ${classes.mb15}`}>
              {t('patientDocument.description.complete')}
            </p>

            <p className={`${classes.textDescription} ${classes.mb10}`}>
              {t('patientDocument.description.question', {
                amount: numberDocument
              })}
            </p>

            <p className={`${classes.textDescription} ${classes.mb15}`}>
              {t('patientDocument.description.info')}
            </p>

            <p className={`${classes.textDescription} ${classes.mb30}`}>
              {t('patientDocument.description.callAt')}{' '}
              {token ? (
                <>
                  <PhoneLink href={`tel:${getTenantInfoByKey('officeNumber')}`}>
                    {formatPhoneNumber(getTenantInfoByKey('officeNumber'))}
                  </PhoneLink>{' '}
                  {t('patientDocument.description.mailAt')}{' '}
                  <span className={classes.textLink} onClick={showDialog}>
                    {getTenantInfoByKey('emailAddress')}.
                  </span>
                </>
              ) : (
                <>
                  <PhoneLink href={`tel:${getTenantInfoByKey('officeNumber')}`}>
                    {formatPhoneNumber(getTenantInfoByKey('officeNumber'))}
                  </PhoneLink>{' '}
                  {t('patientDocument.description.mailAt')}{' '}
                  <span>{getTenantInfoByKey('emailAddress')}.</span>
                </>
              )}
            </p>

            {listDocument.map((documentSection, index) => {
              return (
                <React.Fragment key={`document-section-${index}`}>
                  <AccordionWrapper
                    className={classes.accordionRoot}
                    square={true}
                    expanded={expanded === `panel${index}`}
                    onChange={handleChangeAccordion(`panel${index}`)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <TypographyWrapper>
                        {' '}
                        {getTitleName(
                          `${documentSection.nameFirst} ${documentSection.nameLast}`
                        )}{' '}
                      </TypographyWrapper>
                    </AccordionSummary>
                    <AccordionDetailsWrapper>
                      <Grid
                        item={true}
                        sm={12}
                        className="patient-document__list-doc"
                      >
                        <Card
                          className={`${classes.pt0} ${classes.pb0} ${classes.borderRadius10}`}
                        >
                          <Grid
                            item={true}
                            sm={12}
                            className="patient-document__list-doc"
                          >
                            <Card
                              className={`${classes.pt0} ${classes.pb0} ${classes.borderRadius10}`}
                            >
                              <CardContentWrapper>
                                {documentSection.documents.map((form) => {
                                  let ownerId = contactId;
                                  if (documentSection.contactId) {
                                    ownerId = documentSection.contactId;
                                  }
                                  const formProps = {
                                    ...form,
                                    ownerId
                                  };

                                  return (
                                    <FormItem key={form.id}>
                                      <Title>{form.name}</Title>
                                      {handleRenderAction(formProps)}
                                    </FormItem>
                                  );
                                })}
                              </CardContentWrapper>
                            </Card>
                          </Grid>
                        </Card>
                      </Grid>
                    </AccordionDetailsWrapper>
                  </AccordionWrapper>
                </React.Fragment>
              );
            })}
          </>
        )}
        <EmailPopup
          values={values}
          touched={touched}
          errors={errors}
          dirty={dirty}
          isSubmitting={isSubmitting}
          handleChange={handleChange}
          handleBlur={handleBlur}
          handleSubmit={handleSubmit}
          showPopup={showPopup}
          hideDialog={hideDialog}
          isLoading={isLoadingEmail}
          setIsLoading={setIsLoadingEmail}
          isErrorWhenSendEmail={isErrorWhenSendEmail}
        />
        <ConfirmationDialog
          open={showConfirmPopup}
          confirmHandler={handleConfirmClosingEmail}
          cancelHandler={handleDenyClosingEmail}
          textTitle={t('patientDocument.sendMessages.cancelPopup.title')}
          textDescription={t(
            'patientDocument.sendMessages.cancelPopup.description'
          )}
        />
      </Container>
    </LoadingContainer>
  );
};

export default PatientDocument;
